import { render, staticRenderFns } from "./BusinessNameRegistry.vue?vue&type=template&id=5439bbd4&scoped=true&"
import script from "./BusinessNameRegistry.vue?vue&type=script&lang=js&"
export * from "./BusinessNameRegistry.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameRegistry.vue?vue&type=style&index=0&id=5439bbd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5439bbd4",
  null
  
)

export default component.exports